// extracted by mini-css-extract-plugin
export default {"line":"NewsView_line__yMH3m","News":"NewsView_News__lChQ2","row":"NewsView_row__Nbebe"};